<template>
  <div
    v-if="isSharePath || isUrlCheckerPath"
    class="login-header-box"
  >
    <div
      v-if="isSharePath"
      class="login-header-text"
    >
      {{ $t('ny5dbFMaFI9SvVzi0Ezl') }}
    </div>
    <div
      v-if="isUrlCheckerPath"
      class="login-header-text"
    >
      {{ $t('JMjHGK9REhS8zRpi2W') }}
    </div>
    <div class="header-tags">
      <div
        v-for="(item, index) in featureList"
        :key="item + index"
        class="header-tag"
      >
        <div class="header-tag-icon" />
        <div class="header-tag-text">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { removeLocaleFromPath } from '#imports'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { RoutePath } from '~/types/enum'

const { t: $t } = useI18n()
const featureList = [
  $t('g4CcSjUd8RqKqTWoUitq'),
  $t('yKqHqWkcUpN6_7g8dyhqy'),
  $t('5mCq7CmTcQqoqo0Np83Ec'),
]

const route = useRoute()
const isSharePath = computed(() => /(\/.*)?\/s\//i.test(route.path))
const isUrlCheckerPath = computed(() => removeLocaleFromPath(route.path) === RoutePath.URL_CHECKER)
</script>

<style
  lang="less"
  scoped
>
.login-header-text {
  font-size: 18px;
  color: #000;
  font-weight: 600;
  line-height: 1.4em;
}

.login-header-subtitle {
  font-size: 16px;
  line-height: 22px;
}

.login-header-box {
  padding-inline: 24px;
  padding-top: 32px;
}

.header-tags {
  display: flex;
  margin-top: 4px;
}

.header-tag + .header-tag {
  margin-left: 20px;
}

.header-tag {
  display: flex;
  align-items: center;

  .header-tag-icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    background: url("@/assets/images/common/icon-features.png") no-repeat center / contain;
  }
}
</style>
